import {defineRecipe} from '@chakra-ui/react3'

const chipRecipe = defineRecipe({
    className: 'leap-chip',
    base: {
        display: 'inline-flex',
        whiteSpace: 'nowrap',
        paddingBlock: 'spacing-8',
        paddingInline: 'spacing-16',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 'spacing-8',
        borderRadius: 'round',
        backgroundColor: 'background.actions.ghost',
        color: 'text.primary',
        textStyle: 'heading.small',
        cursor: 'pointer',
        _disabled: {
            cursor: 'not-allowed'
        },
        _hover: {
            backgroundColor: 'background.actions.ghost-hover'
        },
        _focusVisible: {
            outline: '1px solid',
            outlineColor: 'border.strong',
            outlineOffset: '2px'
        }
    },
    variants: {
        variant: {
            default: {
                _selected: {
                    backgroundColor: 'background.actions.carousel-bar'
                }
            },
            configurator: {
                _selected: {
                    backgroundColor: 'background.actions.secondary',
                    color: 'text.primary-inverted'
                },
                _hover: {
                    color: 'text.primary'
                }
            }
        }
    },
    defaultVariants: {
        variant: 'default'
    }
})

export default chipRecipe
